import { ReactNode } from 'react';
import Loader from './Loader';

interface LoadingCellProps {
  isLoading: boolean;
  children: ReactNode;
}

export default function LoadingCell({
  isLoading,
  children,
}: LoadingCellProps): JSX.Element {
  return <>{isLoading ? <Loader size='SMALL' color='GREEN' /> : children}</>;
}
